import type { Locale } from "@/shared/lib/i18n"

export const streamKeys = {
	all: ["stream"] as const,
	messages: () => [...streamKeys.all, "messages"] as const,
	messageList: (locale: Locale) => [...streamKeys.messages(), locale] as const,
	status: (locale: Locale) => [...streamKeys.all, "status", locale] as const,
} as const
